import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Card, CardContent, Typography, Grid } from "@mui/material";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend
);

const ChartsSection = () => {
  const lineData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May"],
    datasets: [
      {
        label: "Crop Yield",
        data: [120, 200, 150, 80, 250],
        fill: true,
        borderColor: "#4caf50",
        backgroundColor: "rgba(76, 175, 80, 0.2)",
        tension: 0.4,
      },
    ],
  };

  const barData = {
    labels: ["Seeds", "Fertilizers", "Labor", "Transport"],
    datasets: [
      {
        label: "Input Costs",
        data: [400, 600, 700, 300],
        backgroundColor: "#2196f3",
      },
    ],
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Card elevation={2}>
          <CardContent>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Crop Yield
            </Typography>
            <Line data={lineData} height={300} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card elevation={2}>
          <CardContent>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Input Costs
            </Typography>
            <Bar data={barData} height={300} />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ChartsSection;
